export default function useSequentialModals() {
  const modalSequence = ref(null);
  const modals = ref({
    modalRef: null,
    modalValidator: false,
    nextModalRef: null,
    nextModalValidator: false,
  });
  let proceedFn = () => null;

  // "private" methods (uses internal data state to prevent being called directly from components)
  function handleModalDisplay() {
    // Check to see if the validator is true for the first modal
    if (modals.value.modalValidator === true) {
      return modals.value.modalRef.open();
    }
    // The validator is false so open the next modal
    return handleSequentialModals({
      ...modals.value,
      modalSequence: 2,
      proceedFn: proceedFn,
    });
  }

  function handleNextModalDisplay() {
    // Close the first modal
    modals.value.modalRef.close();

    // Check to see if the validator is true for the next modal
    if (modals.value.nextModalValidator === true) {
      return modals.value.nextModalRef.open();
    }
    // We need to call proceedFn here since the fist modal is valid and the second is not
    return proceedFn();
  }

  // Component methods
  function handleSequentialModals({
    modalRef = null,
    modalValidator = false,
    nextModalRef = null,
    nextModalValidator = false,
    proceedFn: providedProceedFn = () => null,
    modalSequence: providedSequence = 1,
  } = {}) {
    // Initially persist the state for sequential operations
    modalSequence.value = providedSequence;
    proceedFn = providedProceedFn;
    modals.value = {
      modalRef,
      modalValidator,
      nextModalRef,
      nextModalValidator,
    };

    // Early exit; 2 modals required, and at least one valid case
    if (modalRef === null || nextModalRef === null) {
      return proceedFn();
    }

    if (modalValidator === false && nextModalValidator === false) {
      return proceedFn();
    }

    switch (providedSequence) {
      case 1:
        return handleModalDisplay();
      case 2:
        return handleNextModalDisplay();
      default:
        return null;
    }
  }

  function handleNextOrCloseSequentialModal() {
    switch (modalSequence.value) {
      case 1:
        return handleSequentialModals({
          ...modals.value,
          modalSequence: 2,
          proceedFn: proceedFn(),
        });
      case 2:
        // Next is being called on the last modal which is a close and proceed
        modals.value.nextModalRef.close();
        return proceedFn();
      default:
        return null;
    }
  }

  return {
    handleSequentialModals,
    handleNextOrCloseSequentialModal,
  };
}
